import { render, staticRenderFns } from "./DrawCanvasImage.vue?vue&type=template&id=2e5854bf"
import script from "./DrawCanvasImage.vue?vue&type=script&lang=js"
export * from "./DrawCanvasImage.vue?vue&type=script&lang=js"
import style0 from "./DrawCanvasImage.vue?vue&type=style&index=0&id=2e5854bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports